import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { fetchAppointmentById, createAppointment, updateAppointment } from './appointmentSlice';
import { AppointmentFormData, TimeBlock, WeekDayAvailability } from './types';
import { AppDispatch, RootState } from '@app/store';
import { fetchUsers } from '@features/user/UserSlice';
import { UserOutputDTO } from '@features/user/types';
import { Box, Button, Checkbox, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { Card, CardContent } from '@/components/ui/card';
import { fetchAffiliates } from "../affiliate/AffiliateSlice";
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  Add as AddIcon,
} from "@mui/icons-material";
import { Input } from "@components/ui/input";
import { Camera, Plus, Trash } from 'lucide-react';
import { fetchProducts } from '../Element/productSlice';
import { maskNumberInteger } from '@/utils/maskUtils';

async function readFileAsDataURL(file: any) {
  let result_base64 = await new Promise((resolve) => {
    let fileReader = new FileReader();
    fileReader.onload = (e) => resolve(fileReader.result);
    fileReader.readAsDataURL(file);
  });

  console.log(result_base64); // aGV5IHRoZXJl...

  return result_base64;
}

const AppointmentForm: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const isEditing = Boolean(id);

  const [loading_all, setLoadingAll] = useState(true);

  const currentAppointment: any = useSelector((state: RootState) => state.appointment.currentItem);
  const loading = useSelector((state: RootState) => state.appointment.loading);
  const [loading_save, setLoading] = useState(false)
  // Carregar usuários do estado global
  const users = useSelector((state: RootState) => state.user?.items || []);
  const usersLoading = useSelector((state: RootState) => state.user?.loading);
  const [users_selects, setUsersSelected] = useState({});
  const [roles_selects, setRolesSelected] = useState({});

  const [type_sector, setTypeSector] = useState('');
  const [selectedArea, setSelectedArea] = useState({});
  const [selectedRole, setSelectedRole] = useState({});
  const [selectedColaborators, setSelectedColaborator] = useState({});


  const [selectTypeShare, setSelectTypeShare] = useState('own');

  const [type_sectorWhoShare, setTypeSectorWhoShare] = useState('');

  const [selectedAreaWhoShare, setSelectedAreaWhoShare] = useState({});
  const [selectedRoleWhoShare, setSelectedRoleWhoShare] = useState({});
  const [selectedColaboratorsWhoShare, setSelectedColaboratorWhoShare] = useState({});


  const [type_sectorThirdShare, setTypeSectorThirdShare] = useState('');
  const [selectedAreaThirdShare, setSelectedAreaThirdShare] = useState({});
  const [selectedRoleThirdShare, setSelectedRoleThirdShare] = useState({});
  const [selectedColaboratorsThirdShare, setSelectedColaboratorThirdShare] = useState({});




  const { items: affiliates, loading: affiliatesLoading } = useSelector(
    (state: RootState) => state.affiliate
  );

  const { products, loading: loading_products, error } = useSelector((state: RootState) => state.product);

  console.log(products)

  const [formData, setFormData] = useState<AppointmentFormData>({
    name: '',
    description: '',
    image: null,
    product: '',
    type: 'operacional',
    phase: '',
    activity: '',
    email: '',
    minimumAdvanceDays: '',
    maximumFutureDays: '',
    intervalMinutes: '',
    type_appointment: 'individual',
    // timeBlocks: [{ startTime: '09:00', endTime: '10:00',
    //   day:'monday'
    //  },{ startTime: '09:00', endTime: '10:00',
    //   day:'tuesday'
    //  },{ startTime: '09:00', endTime: '10:00',
    //   day:'wednesday'
    //  },{ startTime: '09:00', endTime: '10:00',
    //   day:'thursday'
    //  },{ startTime: '09:00', endTime: '10:00',
    //   day:'friday'
    //  },{ startTime: '09:00', endTime: '10:00',
    //   day:'saturday'
    //  },{ startTime: '09:00', endTime: '10:00',
    //   day:'sunday'
    //  }],
    timeBlocks: {
      'monday': [{ startTime: '09:00', endTime: '10:00' }],
      'tuesday': [{ startTime: '09:00', endTime: '10:00' }],
      'wednesday': [{ startTime: '09:00', endTime: '10:00' }],
      'thursday': [{ startTime: '09:00', endTime: '10:00' }],
      'friday': [{ startTime: '09:00', endTime: '10:00' }],
      'saturday': [{ startTime: '09:00', endTime: '10:00' }],
      'sunday': [{ startTime: '09:00', endTime: '10:00' }],
    },
    weekDayAvailability: {
      monday: true,
      tuesday: true,
      wednesday: true,
      thursday: true,
      friday: true,
      saturday: false,
      sunday: false
    },
    userPoolIndividual: {
      sectors:[],
      areas:[],
      roles:[],
      users:[]
    },
    userPoolWhoShare: {
      sectors:[],
      areas:[],
      roles:[],
      users:[]
    },
    userPoolThirdShare: {
      sectors:[],
      areas:[],
      roles:[],
      users:[]
    },
    // rolePool: [],
  });
  const isLoadingRef = useRef(false);

  const [errors, setErrors] = useState<Record<string, string>>({});

  useEffect(() => {
    const loadData = async () => {
      setLoadingAll(true);
      if (isLoadingRef.current) {
        return;
      }

      try {
        console.log("📡 Iniciando carregamento do Usuário:", id);
        isLoadingRef.current = true;

        // Load affiliates
        console.log("📡 RoleForm - Carregando Afiliados");
        await dispatch(fetchAffiliates({}));

        await dispatch(fetchProducts());


        // if (id) {
        //   console.log("📡 RoleForm - Carregando Usuário:", id);
        //   const resultAction = await dispatch(fetchRoleById(id));

        //   if (fetchRoleById.fulfilled.match(resultAction)) {
        //     console.log("✅ Usuário carregado com sucesso");
        //   } else {
        //     throw new Error("Erro ao carregar dados");
        //   }
        // }
      } catch (error) {
        console.error("❌ Erro ao carregar Usuário:", error);
        // setFormError({
        //   message: "Erro ao carregar dados",
        //   code: "LOAD_ERROR",
        //   statusCode: 500,
        // });
      } finally {
        isLoadingRef.current = false;
        setLoadingAll(false);

        // initialLoadDoneRef.current = true;
        // setIsInitialLoad(false);
      }
    };

    loadData();

    return () => {
      console.log("🧹 Limpando estado do formulário");
      // dispatch(RoleActions.clearCurrentItem());
    };
  }, [dispatch, id]);


  // Carregar usuários ao montar o componente
  useEffect(() => {
    console.log('Carregando usuários...');
    dispatch(fetchUsers({}))
      .unwrap()
      .then(response => {
        console.log('Usuários carregados:', response);
      })
      .catch(error => {
        console.error('Erro ao carregar usuários:', error);
      });
  }, [dispatch]);

  // Efeito para monitorar mudanças na lista de usuários
  useEffect(() => {
    console.log('Lista de usuários atualizada:', users);
  }, [users]);

  useEffect(() => {
    if (isEditing && id) {
      dispatch(fetchAppointmentById(id));
    }
  }, [dispatch, id, isEditing]);

  useEffect(() => {
    if (affiliates.length > 0 && type_sector == '') {
      setTypeSector(affiliates[0]?.sectors[0]?._id ?? '');
      setTypeSectorWhoShare(affiliates[0]?.sectors[0]?._id ?? '');
      setTypeSectorThirdShare(affiliates[0]?.sectors[0]?._id ?? '');

    }
    if (isEditing && currentAppointment) {
      let timeblocks: any = {
        'monday': [],
        'tuesday': [],
        'wednesday': [],
        'thursday': [],
        'friday': [],
        'saturday': [],
        'sunday': [],
      };
      for (let i = 0; i < currentAppointment.timeBlocks.length; i++) {
        if (currentAppointment.timeBlocks[i].day == undefined) {
          Object.keys(timeblocks).map((item: any) => {
            timeblocks[item].push({ ...currentAppointment.timeBlocks[i] })
          })
        }
        else {
          timeblocks[currentAppointment.timeBlocks[i].day].push({ ...currentAppointment.timeBlocks[i] })
        }
      }
      // Object.keys(timeblocks).map((item2)=>{
      //   if(!Array.isArray(timeblocks[item2])){
      //     timeblocks[item2]=[timeblocks[item2]]
      //   }
      // })
      setFormData({
        name: currentAppointment.name,
        description: currentAppointment.description || '',
        type_appointment: currentAppointment.type_appointment || 'individual',
        type: currentAppointment.type || 'operacional',


        product: currentAppointment.product,
        phase: currentAppointment.phase,
        activity: currentAppointment.activity,
        email: currentAppointment.email,
        image: currentAppointment.image,


        minimumAdvanceDays: currentAppointment.minimumAdvanceDays,
        maximumFutureDays: currentAppointment.maximumFutureDays,
        intervalMinutes: currentAppointment.intervalMinutes,
        timeBlocks: timeblocks,
        weekDayAvailability: currentAppointment.weekDayAvailability,
        // userPoolIndividual: currentAppointment.userPoolIndividual

      });

      if(currentAppointment.userPoolIndividual){
        // const sectors = currentAppointment.userPoolIndividual.sectors.reduce((acc, current, index) => {
        //   acc[current] = {_id:current,name:''};
        //   return acc;
        // }, {});
        const areas = currentAppointment.userPoolIndividual.areas.reduce((acc, current, index) => {
          acc[current] = {_id:current,name:''};
          return acc;
        }, {});
         const roles = currentAppointment.userPoolIndividual.roles.reduce((acc, current, index) => {
          acc[current] = {_id:current,name:''};
          return acc;
        }, {});
        const users = currentAppointment.userPoolIndividual.users.reduce((acc, current, index) => {
          acc[current] = {_id:current,name:''};
          return acc;
        }, {});
        setTypeSector(currentAppointment.userPoolIndividual.sectors[0]);
        setSelectedRole(roles);
        setSelectedColaborator(users);
        setSelectedArea(areas);
      }
      if(currentAppointment.userPoolWhoShare){
        // const sectors = currentAppointment.userPoolIndividual.sectors.reduce((acc, current, index) => {
        //   acc[current] = {_id:current,name:''};
        //   return acc;
        // }, {});
        const areas = currentAppointment.userPoolWhoShare.areas.reduce((acc, current, index) => {
          acc[current] = {_id:current,name:''};
          return acc;
        }, {});
         const roles = currentAppointment.userPoolWhoShare.roles.reduce((acc, current, index) => {
          acc[current] = {_id:current,name:''};
          return acc;
        }, {});
        const users = currentAppointment.userPoolWhoShare.users.reduce((acc, current, index) => {
          acc[current] = {_id:current,name:''};
          return acc;
        }, {});
        setTypeSectorWhoShare(currentAppointment.userPoolWhoShare.sectors[0]);
        setSelectedRoleWhoShare(roles);
        setSelectedColaboratorWhoShare(users);
        setSelectedAreaWhoShare(areas);
      }

      if(currentAppointment.userPoolThirdShare){
        // const sectors = currentAppointment.userPoolIndividual.sectors.reduce((acc, current, index) => {
        //   acc[current] = {_id:current,name:''};
        //   return acc;
        // }, {});
        const areas = currentAppointment.userPoolThirdShare.areas.reduce((acc, current, index) => {
          acc[current] = {_id:current,name:''};
          return acc;
        }, {});
         const roles = currentAppointment.userPoolThirdShare.roles.reduce((acc, current, index) => {
          acc[current] = {_id:current,name:''};
          return acc;
        }, {});
        const users = currentAppointment.userPoolThirdShare.users.reduce((acc, current, index) => {
          acc[current] = {_id:current,name:''};
          return acc;
        }, {});
        setTypeSectorThirdShare(currentAppointment.userPoolThirdShare.sectors[0]);
        setSelectedRoleThirdShare(roles);
        setSelectedColaboratorThirdShare(users);
        setSelectedAreaThirdShare(areas);
      }

        // rolePool: currentAppointment.rolePool,

      // let users_: any = {}
      // users?.filter((item: any) => {
      //   if (currentAppointment.userPool?.includes(item._id)) users_[item._id] = item;
      // });
      // let roles_: any = {}

      // affiliates[0]?.roles?.map((item: any) => {
      //   if (currentAppointment.rolePool.includes(item._id)) roles_[item._id] = item;
      // });

      // setUsersSelected(users_)
      // setRolesSelected(roles_)

    }
  }, [currentAppointment, isEditing, users, affiliates]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    if (name == 'product') {
      setFormData(prev => ({ ...prev, [name]: value, 'activity': '', 'phase': '' }));
    }
    else if (name == 'phase') {
      setFormData(prev => ({ ...prev, [name]: value, 'activity': '' }));
    }
    else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: parseInt(maskNumberInteger(value)) || '' }));
  };

  const handleWeekDayChange = (day: keyof WeekDayAvailability) => {
    setFormData(prev => ({
      ...prev,
      weekDayAvailability: {
        ...prev.weekDayAvailability,
        [day]: !prev.weekDayAvailability[day]
      }
    }));
  };

  const handleTimeBlockChange = (day: string, index3: any, field: keyof TimeBlock, value: string) => {
    let updatedTimeBlocks: any = { ...formData.timeBlocks };
    updatedTimeBlocks[day] = [...updatedTimeBlocks[day]];
    console.log(updatedTimeBlocks, day, index3, field)
    updatedTimeBlocks[day][index3] = { ...updatedTimeBlocks[day][index3] }
    updatedTimeBlocks[day][index3][field] = value;
    setFormData(prev => ({ ...prev, timeBlocks: updatedTimeBlocks }));
  };

  const addTimeBlock = (day: any) => {
    let timeBlocks = { ...formData.timeBlocks };
    timeBlocks[day] = [...timeBlocks[day]];

    timeBlocks[day].push({ startTime: '09:00', endTime: '10:00' })
    setFormData(prev => ({
      ...prev,
      timeBlocks: timeBlocks
    }));
  };

  const removeTimeBlock = (day: any) => {

    // if (formData.timeBlocks[day].length > 1) {
    let timeBlocks = { ...formData.timeBlocks };
    console.log(timeBlocks)
    timeBlocks[day] = [...timeBlocks[day]];
    timeBlocks[day].pop()
    setFormData(prev => ({ ...prev, timeBlocks: timeBlocks }));
    // }
  };

  const handleUserPoolChange = (e: any) => {
    // const selectedOptions = Array.from(e.target.selectedOptions, option => option.value);
    // setFormData(prev => ({ ...prev, userPool: selectedOptions }));
    let users_: any = { ...users_selects }
    users_[e.target.value] = users.filter((item: any) => item._id == e.target.value)[0]
    setUsersSelected(users_);
  };

  const handleProfileDelete = (id: string) => {
    let users_: any = { ...roles_selects }
    delete users_[id]
    setRolesSelected(users_);

  }

  const handleProfilePoolChange = (e: any) => {
    // const selectedOptions = Array.from(e.target.selectedOptions, option => option.value);
    // setFormData(prev => ({ ...prev, userPool: selectedOptions }));
    let roles_: any = { ...roles_selects }
    roles_[e.target.value] = affiliates[0]?.roles.filter((item: any) => item._id == e.target.value)[0]
    setRolesSelected(roles_);
  };

  const handleDeleteUser = (id: string) => {
    let users_: any = { ...users_selects }
    delete users_[id]
    setUsersSelected(users_);

  }

  const validateForm = (): boolean => {
    const newErrors: Record<string, string> = {};

    // Validar nome
    if (!formData.name.trim()) {
      newErrors.name = 'O nome é obrigatório';
    }

    if (!formData.product.trim()) {
      newErrors.product = 'O Produto é obrigatório';
    }

    if (!formData.phase.trim()) {
      newErrors.phase = 'A Fase é obrigatória';
    }

    if (!formData.activity.trim()) {
      newErrors.phase = 'A Atividade é obrigatória';
    }

    // Validar dias mínimos de antecedência
    if (formData.minimumAdvanceDays < 0) {
      newErrors.minimumAdvanceDays = 'A Disponíbilidade inicial não pode ser negativa';
    }

    // Validar dias máximos futuros
    if (formData.maximumFutureDays <= 0) {
      newErrors.maximumFutureDays = 'O Tempo da reunião deve ser maior que zero';
    }

    // Validar intervalo em minutos
    if (formData.intervalMinutes <= 0) {
      newErrors.intervalMinutes = 'O intervalo deve ser maior que zero';
    }

    // Validar blocos de horário
    if (Object.keys(formData.timeBlocks).length === 0) {
      newErrors.timeBlocks = 'É necessário pelo menos um bloco de horário';
    } else {
      const timeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;

      Object.keys(formData.timeBlocks).forEach((item2: any, index2) => {
        let hours: any = [];
        formData.timeBlocks[item2].map((block: any, index: any) => {
          let error = false;
          if (!timeRegex.test(block.startTime)) {
            newErrors[`timeBlocks[${item2}][${index}].startTime`] = 'Formato inválido (use HH:MM)';
            error = true;
          }

          if (!timeRegex.test(block.endTime)) {
            newErrors[`timeBlocks[${item2}][${index}].endTime`] = 'Formato inválido (use HH:MM)';
            error = true;

          }

          if (timeRegex.test(block.startTime) && timeRegex.test(block.endTime)) {
            const [startHour, startMinute] = block.startTime.split(':').map(Number);
            const [endHour, endMinute] = block.endTime.split(':').map(Number);

            const startMinutes = startHour * 60 + startMinute;
            const endMinutes = endHour * 60 + endMinute;

            if (endMinutes <= startMinutes) {
              newErrors[`timeBlocks[${item2}][${index}].endTime`] = 'O horário de término deve ser posterior ao de início';
              error = true;

            }
          }
          if (error == false) {
            hours.map((item_hour: any) => {
              if (item_hour.startTime <= block.startTime && item_hour.endTime >= block.startTime) {
                newErrors[`timeBlocks[${item2}][${index}].startTime`] = 'O horário de ínicio choca horário com outros intervalos';

              }
              else if (item_hour.startTime <= block.endTime && item_hour.endTime >= block.endTime) {
                newErrors[`timeBlocks[${item2}][${index}].endTime`] = 'O horário de ínicio choca horário com outros intervalos';
              }
            })
            console.log('choque', newErrors)

            hours.push({ ...block })
          }
        })

      });
    }

    // Validar pool de usuários
    // if (formData.userPool.length === 0) {
    //   newErrors.userPool = 'É necessário selecionar pelo menos um usuário';
    // }

    // if (Object.values(users_selects).length == 0 && Object.values(roles_selects).length == 0) {
    //   newErrors.userPool = 'É necessário selecionar pelo menos um usuário ou perfil';
    // }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }
    setLoading(true)
    // formData.userPool = Object.keys(users_selects);
    // formData.rolePool = Object.keys(roles_selects);
    formData.userPoolIndividual = {
      sectors:[type_sector],
      areas:Object.keys(selectedArea),
      roles:Object.keys(selectedRole),
      users:Object.keys(selectedColaborators),
    }

    formData.userPoolWhoShare = {
      sectors:[type_sectorWhoShare],
      areas:Object.keys(selectedAreaWhoShare),
      roles:Object.keys(selectedRoleWhoShare),
      users:Object.keys(selectedColaboratorsWhoShare),
    }

    formData.userPoolThirdShare = {
      sectors:[type_sectorThirdShare],
      areas:Object.keys(selectedAreaThirdShare),
      roles:Object.keys(selectedRoleThirdShare),
      users:Object.keys(selectedColaboratorsThirdShare),
    }

    let timeblocks: any = [];
    Object.keys(formData.timeBlocks).map((item: any) => {
      for (let j = 0; j < formData.timeBlocks[item].length; j++) {
        timeblocks.push({ day: item, ...formData.timeBlocks[item][j] });
      }
    })

    if (formData?.image instanceof File) {
      formData.image = await readFileAsDataURL(formData.image);
    }
    else {
      delete formData.image;
    }
    console.log(formData)
    if (isEditing && id) {
      dispatch(updateAppointment({ id, data: { ...formData, timeBlocks: timeblocks } }));
    } else {
      dispatch(createAppointment({ ...formData, timeBlocks: timeblocks }));
    }
    setLoading(false)

    navigate('/appointments');
  };

  const handleFileChange = (e: any) => {
    console.log(e.target.name, e.target.files[0])
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.files[0] }));

  }

  const calculateLoopHour = () => {
    let length_ = 1;
    Object.values(formData.timeBlocks).map((item2: any) => {
      if (item2.length > length_) {
        length_ = item2.length;
      }
    })
    console.log(new Array(length_))
    return new Array(length_).fill(length_);
  }



  if ((loading && isEditing) || usersLoading) {
    return <div className="flex flex-col flex-1 shrink  self-stretch px-6 py-7 basis-0 min-w-60 max-md:px-5 bg-background-dark mx-auto p-4 flex justify-center items-center min-h-[300px]">
      <div className="animate-pulse text-lg">Carregando...</div>
    </div>;
  }



  return (
    <div className="flex flex-col flex-1 shrink  self-stretch px-6 py-7 basis-0 min-w-60 max-md:px-5 bg-background-dark">
      <h1 className="text-2xl font-bold mb-6">
        {isEditing ? 'Editar Configuração de Agendamento' : 'Nova Configuração de Agendamento'}
      </h1>
      <Card className="w-full border border-[#D8E0F0] rounded-[14px] bg-[#FCFCFC] hover:border-[#c8d0e0] transition-colors">
        <CardContent className="p-[20px] " style={{ position: 'relative' }}>
          <div style={{ height: window.innerHeight - 200, overflow: 'scroll' }} className='custom-scrollbar'>


            {loading_all == false && <form id="appointment_form" onSubmit={handleSubmit} >
              {/* Informações básicas */}
              {/* <div className="mb-6 p-4 bg-gray-50 rounded-lg"> */}
              <div>
                <div style={{ position: 'relative', display: 'flex' }}>
                  <input type='file' accept='image/*' id={'image'} name={'image'} onChange={handleFileChange} hidden />
                  <div onClick={() => document.getElementById('image')?.click()} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer', minWidth: 100, minHeight: 100, width: 100, height: 100, borderRadius: 10, border: '2px solid lightgrey', padding: 5, overflow: 'hidden', background: '#F4F4F4' }}>
                    {formData.image && <img style={{ borderRadius: 10, minWidth: 90, minHeight: 90, width: 100, height: 100, objectFit: 'cover' }} src={formData.image ? (formData.image instanceof File ? URL.createObjectURL(formData.image) : formData.image) : '/agenda.svg'} />}
                    {!formData.image && <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 20 16" >
                      <path d="M0.52656 12.8H14.3084C14.432 12.8 14.5515 12.7562 14.6463 12.6765C14.7786 12.5644 17.7982 9.9374 17.9824 4.26666H3.18091C2.99749 9.41417 0.216574 11.8336 0.187674 11.8578C0.0182484 12.0026 -0.0440864 12.239 0.0321357 12.4495C0.107831 12.6594 0.305101 12.8 0.52656 12.8Z" fill="#3975C9" />
                      <path d="M17.4726 1.06666H14.8358V0.533332C14.8358 0.234666 14.6037 0 14.3084 0C14.0131 0 13.781 0.234666 13.781 0.533332V1.06666H11.109V0.533332C11.109 0.234666 10.877 0 10.5817 0C10.2863 0 10.0543 0.234666 10.0543 0.533332V1.06666H7.41746V0.533332C7.41746 0.234666 7.18542 0 6.89009 0C6.59477 0 6.36272 0.234666 6.36272 0.533332V1.06666H3.72589C3.43056 1.06666 3.19852 1.30133 3.19852 1.6V3.19999H18V1.6C18 1.30133 17.7679 1.06666 17.4726 1.06666Z" fill="#3975C9" />
                      <path d="M15.3235 13.4943C15.0371 13.7354 14.6777 13.8667 14.3084 13.8667H3.19855V15.4667C3.19855 15.7615 3.43443 16 3.72592 16H17.4726C17.7641 16 18 15.7615 18 15.4667V9.48816C16.9832 12.0109 15.5644 13.2904 15.3235 13.4943Z" fill="#3975C9" />
                    </svg>}
                  </div>
                  <div onClick={() => document.getElementById('image')?.click()} style={{ cursor: 'pointer', boxShadow: "rgba(0, 0, 0, 0.2) -1px 2px 1px 0px", padding: 2, position: 'absolute', top: 80, left: 70, background: 'white', borderRadius: 10, overflow: 'hidden' }}>
                    <Camera width={18} height={18} />
                  </div>
                  <div style={{ padding: 10, paddingTop: 20 }}>
                    <p style={{ fontSize: 16 }}><b>{formData?.name}</b></p>
                    <p style={{ fontSize: 14 }}>{formData?.product != '' && products.filter((item) => item._id == formData.product)[0].name}</p>
                  </div>
                </div>
              </div>
              <br />
              <h2 className="text-lg font-semibold mb-4">Dados principais</h2>
              {/* <hr /> */}
              <div style={{ background: '#f2f2f2', padding: 7, borderRadius: 10 }}>
                <div style={{ background: 'white', borderRadius: 10, padding: 10 }}>

                  <div className="mb-4 mt-4">
                    {/* <label className="block mb-2 font-medium">Nome da Configuração *</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className={`p-2 border rounded w-full ${errors.name ? 'border-red-500' : ''}`}
                required
              /> */}

                    <label className="text-sm font-semibold text-gray-700">
                      Nome da Configuração {<b style={{ color: 'red' }}>*</b>}
                    </label>
                    <Input
                      name="name"

                      required
                      className={`h-12 rounded-xl border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 ${errors.name ? "border-red-500" : ""
                        }`}
                      type={'text'}
                      value={formData.name}
                      onChange={handleChange}
                      placeholder={'Nome da Configuração'}
                    />
                    {errors.name && <p className="text-red-500 text-sm mt-1">{errors.name}</p>}

                  </div>
                  <div className="mb-4">
                    <label className="text-sm font-semibold text-gray-700">
                      Produto {<b style={{ color: 'red' }}>*</b>}
                    </label>
                    <select
                      name="product"
                      value={formData.product}
                      onChange={handleChange}
                      required
                      style={{ fontSize: '0.875rem', padding: 5 }}
                      className={`h-12 w-full border rounded-xl border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 ${errors.product ? "border-red-500" : ""
                        }`}
                    >
                      <option value={''}>
                        Selecione um produto
                      </option>
                      {products?.map((product: any) => (
                        <option key={product._id} value={product._id}>
                          {product.name}
                        </option>
                      ))}
                    </select>
                    {/* <p className="text-sm text-gray-500 mt-1">Segure Ctrl (ou Command) para selecionar múltiplos usuários</p> */}
                    {errors.product && <p className="text-red-500 text-sm mt-1">{errors.product}</p>}
                  </div>
                  <div className="mb-4">
                    <label className="text-sm font-semibold text-gray-700">
                      Atuação (Fluxo do produto) {<b style={{ color: 'red' }}>*</b>}
                    </label>

                    <RadioGroup
                      name={'fluxo'}
                      style={{ display: 'flex', flexDirection: 'row' }}
                      value={formData.type}
                      onChange={(e) => {
                        setFormData(prev => ({ ...prev, type: e.target.value, 'activity': '', 'phase': '' }));
                      }}
                    >

                      <FormControlLabel
                        value={'operacional'}
                        control={<Radio />}
                        label={'Operacional'}
                      />
                      <FormControlLabel
                        value={'comercial'}
                        control={<Radio />}
                        label={'Comercial'}
                      />
                    </RadioGroup>

                  </div>

                  <div className="mb-4">
                    <label className="text-sm font-semibold text-gray-700">
                      Fase {<b style={{ color: 'red' }}>*</b>}
                    </label>
                    <select
                      name="phase"
                      value={formData.phase}
                      onChange={handleChange}
                      required

                      style={{ fontSize: '0.875rem', padding: 5 }}
                      className={`h-12 w-full border rounded-xl border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 ${errors.phase ? "border-red-500" : ""
                        }`}
                    >
                      <option value={''}>
                        Selecione uma fase
                      </option>
                      {formData.product != '' && products.filter((item: any) => item._id == formData.product)[0].phases?.filter((item) => (item.type == undefined && formData.type == 'operacional') || item.type == formData.type)?.map((phase: any) => (
                        <option key={phase._id} value={phase._id}>
                          {phase.name}
                        </option>
                      ))}
                    </select>
                    {/* <p className="text-sm text-gray-500 mt-1">Segure Ctrl (ou Command) para selecionar múltiplos usuários</p> */}
                    {errors.product && <p className="text-red-500 text-sm mt-1">{errors.product}</p>}
                  </div>

                  <div className="">
                    <label className="text-sm font-semibold text-gray-700">
                      Atividade {<b style={{ color: 'red' }}>*</b>}
                    </label>
                    <select
                      name="activity"
                      value={formData.activity}
                      onChange={handleChange}
                      required

                      style={{ fontSize: '0.875rem', padding: 5 }}
                      className={`h-12 w-full mb-4 border rounded-xl border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 ${errors.activity ? "border-red-500" : ""
                        }`}
                    >
                      <option value={''}>
                        Selecione uma atividade
                      </option>
                      {formData.product != '' && formData.phase != '' && products.filter((item: any) => item._id == formData.product)[0].phases?.filter((item: any) => item._id == formData.phase)[0].activities.map((phase: any) => (
                        <option key={phase._id} value={phase._id}>
                          {phase.name}
                        </option>
                      ))}
                    </select>
                    {/* <p className="text-sm text-gray-500 mt-1">Segure Ctrl (ou Command) para selecionar múltiplos usuários</p> */}
                    {errors.product && <p className="text-red-500 text-sm mt-1">{errors.product}</p>}
                  </div>
                </div>
              </div>

              {/* <div className="mb-4">
              <label className="text-sm font-semibold text-gray-700">
                Descrição
              </label>
              <textarea
                name="description"
                className={`h-12 border rounded-xl border-gray-200 rounded-xl w-full border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 ${errors.description ? "border-red-500" : ""
                  }`}
                style={{ fontSize: '0.875rem', padding: 5 }}

                value={formData.description}
                onChange={handleChange}
                placeholder={'Descrição'}
              />
            </div> */}
              {/* </div> */}

              {/* Configurações de tempo */}
              {/* <div className="mb-6 p-4 bg-gray-50 rounded-lg"> */}
              <h2 className="text-lg font-semibold mb-4 mt-4">Tipo de Agenda</h2>
              <div style={{ background: '#f2f2f2', padding: 7, borderRadius: 10 }}>

                <div style={{ display: 'flex', background: 'white', borderRadius: 10, padding: 10 }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name={'type_appointment'}
                        checked={formData.type_appointment == 'share'}
                        onChange={(e) => {
                          if (formData.type_appointment == 'share') {
                            setFormData(prev => ({ ...prev, type_appointment: 'individual' }));

                          }
                          else {
                            setFormData(prev => ({ ...prev, type_appointment: 'share' }));

                          }
                        }}
                      />
                    }
                  // label={'Agenda compartilhada'}
                  />
                  <div>
                    <p style={{ fontSize: 15 }}>Agenda Compartilhada</p>
                    <p style={{ marginTop: 5, color: 'grey', fontSize: 13 }}>
                      Crie uma cópia individual dessa agenda para cada colaborador com permissão e permite que (Colaboradores específicos) tenham acesso a agendas de outros (Colaboradores específicos) para visualizar, editar e excluir seus eventos.
                    </p>
                  </div>
                </div>
              </div>

              <h2 className="text-lg font-semibold  mt-4">Controle de Acesso (Individual)</h2>
              <p style={{ marginTop: 5, color: 'grey', fontSize: 13, marginBottom: 10 }}>
                Defina os colaboradores que terão uma cópia individual desta agenda, acessível apenas por eles.
              </p>
              <div style={{ background: '#f2f2f2', padding: 7, borderRadius: 10, height: 400 }}>

                <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', background: 'white', borderRadius: 10, padding: 10 }}>
                  <b style={{ fontWeight: '500' }}>Setores</b> <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}

                  >
                    {affiliates[0]?.sectors?.map((item, id) => <div onClick={(e) => {
                      setTypeSector(item._id)
                      setSelectedArea({});
                      setSelectedRole({});
                      setSelectedColaborator({});
                    }} style={{ marginLeft: 10, marginRight: 10, color: type_sector == item._id ? '#1777CF' : 'rgba(0, 0, 0, 0.87)' }}>{item.name}</div>)}
                  </div>
                </div>
                <div style={{ display: 'flex', overflow: 'scroll', justifyContent: 'space-between' }}>

                  <div style={{ marginTop: 10, marginRight: 10, background: 'white', width: '32%', minWidth: 200, borderRadius: 10, padding: 10, height: 332, overflow: 'scroll' }}>
                    <b style={{ fontWeight: '500' }}>Áreas</b>
                    {/* <hr/> */}

                    <hr />
                    {type_sector == '' && <p style={{ textAlign: 'center', fontSize: 14, marginTop: 20 }}>Selecione um setor</p>}
                    {affiliates[0]?.areas?.filter((item) => {
                      let sector = affiliates[0]?.sectors?.filter((item2) => item2._id == type_sector)[0];
                      if (sector?.areas?.includes(item._id)) return true;
                      return false;
                    })?.map((item, id) => (
                      <div key={id} style={{ textOverflow: 'ellipsis', padding: 5, marginTop: 10, cursor: 'pointer', border: '1px solid #f2f2f2', borderRadius: 5 }} onClick={(e) => {
                        let items: any = { ...selectedArea };
                        if (items[item._id]) {
                          delete items[item._id]
                        }
                        else {
                          items[item._id] = item;
                        }
                        setSelectedArea(items);
                        // setSelectedRole({});
                        // setSelectedColaborator({});
                      }}><p style={{ color: selectedArea[item._id] ? '#1777CF' : 'rgba(0, 0, 0, 0.87)', display: 'flex', justifyContent: 'space-between' }}><span>{item.name}</span> <span>{item.roles?.length ?? 0}</span></p>
                        {/* <Separator style={{ borderWidth: 0.5, marginTop: 5 }} /> */}
                      </div>
                    ))}
                  </div>
                  <div style={{ marginTop: 10, marginRight: 10, background: 'white', width: '32%', minWidth: 200, borderRadius: 10, padding: 10, height: 332, overflow: 'scroll' }}>
                    <b style={{ fontWeight: '500' }}>Perfis</b>
                    {/* <hr/> */}

                    <hr />
                    {Object.values(selectedArea).length == 0 && <p style={{ textAlign: 'center', fontSize: 14, marginTop: 20 }}>Selecione uma área</p>}

                    {affiliates[0]?.roles.filter((item) => {
                      let areas = Object.values(selectedArea);
                      let find = false;
                      for (let i = 0; i < areas.length; i++) {
                        let area = affiliates[0]?.areas?.filter((item3)=>item3._id==areas[i]._id)[0];
                        // console.log(area,areas[i]);
                        find = area?.roles?.includes(item._id)
                        if (find) {
                          break;
                        }
                      }
                      return find;
                    })?.map((item, id) => (
                      <div key={id} style={{ textOverflow: 'ellipsis', padding: 5, marginTop: 10, cursor: 'pointer', border: '1px solid #f2f2f2', borderRadius: 5 }} onClick={(e) => {


                      }}><p style={{ color: selectedRole[item._id] ? '#1777CF' : 'rgba(0, 0, 0, 0.87)', display: 'flex', justifyContent: 'space-between' }}>
                          <div style={{ display: 'flex', background: 'white', borderRadius: 10, padding: 5 }}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  name={'checkbox_client'}
                                  value={selectedRole[item._id]}
                                  checked={selectedRole[item._id]}
                                  onChange={(e) => {
                                    let items: any = { ...selectedRole };
                                    if (items[item._id]) {
                                      delete items[item._id]
                                    }
                                    else {
                                      items[item._id] = item;
                                    }
                                    setSelectedRole(items);
                                    // setSelectedColaborator({});
                                    // if (formData.type_appointment == 'share') {
                                    //   setFormData(prev => ({ ...prev, type_appointment: 'individual' }));

                                    // }
                                    // else {
                                    //   setFormData(prev => ({ ...prev, type_appointment: 'share' }));

                                    // }
                                  }}
                                />
                              }
                            // label={'Agenda compartilhada'}
                            />
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <p style={{ fontSize: 15 }}>{item.name}</p>
                              {/* <p style={{ marginTop: 5, color: 'grey', fontSize: 13 }}>
                      Crie uma cópia individual dessa agenda para cada colaborador com permissão e permite que (Colaboradores específicos) tenham acesso a agendas de outros (Colaboradores específicos) para visualizar, editar e excluir seus eventos.
                    </p> */}
                            </div>
                          </div>
                        </p>
                        {/* <Separator style={{ borderWidth: 0.5, marginTop: 5 }} /> */}
                      </div>
                    ))}
                  </div>
                  <div style={{ marginTop: 10, background: 'white', width: '32%', minWidth: 200, borderRadius: 10, padding: 10, height: 332, overflow: 'scroll' }}>
                    <b style={{ fontWeight: '500' }}>Colaboradores</b>
                    {/* <hr/> */}

                    <hr />
                    {Object.values(selectedRole).length == 0 && <p style={{ textAlign: 'center', fontSize: 14, marginTop: 20 }}>Selecione um perfil</p>}

                    {users?.filter((item) => {
                      let roles = affiliates[0]?.roles?.filter((item2) => selectedRole[item2._id]).map((item2) => item2._id);
                      let roles_2 = affiliates[0]?.roles?.filter((item2) => selectedRole[item2._id]).map((item2) => item2.name);

                      if (roles.includes(item.role) || roles_2.includes(item.role)) {
                        return true;
                      }
                      return false;
                    })?.map((item, id) => (
                      <div key={id} style={{ marginTop: 10, textOverflow: 'ellipsis', padding: 5, cursor: 'pointer', border: '1px solid #f2f2f2', borderRadius: 5 }} onClick={(e) => {
                        let items: any = { ...selectedColaborators };
                        if (items[item._id]) {
                          delete items[item._id]
                        }
                        else {
                          items[item._id] = item;
                        }
                        setSelectedColaborator(items);
                      }}><p style={{ color: selectedColaborators[item._id] ? '#1777CF' : 'rgba(0, 0, 0, 0.87)', display: 'flex', justifyContent: 'space-between' }}><div style={{ display: 'flex', background: 'white', borderRadius: 10, padding: 5 }}>

                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <div>
                            <img style={{ borderRadius: 100, minWidth: 30, minHeight: 30, width: 30, height: 30, objectFit: 'cover' }} src={item.photoUrl ? (item.photoUrl instanceof File ? URL.createObjectURL(item.photoUrl) : item.photoUrl) : 'https://microbiology.ucr.edu/sites/default/files/styles/form_preview/public/blank-profile-pic.png?itok=4teBBoet'} />

                          </div>
                          <div style={{ marginLeft: 10 }}>

                            <p style={{ fontSize: 15 }}>{item.name}</p>
                            <p style={{ fontSize: 12, color: 'grey' }}>{affiliates[0]?.roles?.filter((item2) => item2._id == item.role || item2.name == item.role)[0]?.name ?? '-f'}</p>

                          </div>

                          {/* <p style={{ marginTop: 5, color: 'grey', fontSize: 13 }}>
                      Crie uma cópia individual dessa agenda para cada colaborador com permissão e permite que (Colaboradores específicos) tenham acesso a agendas de outros (Colaboradores específicos) para visualizar, editar e excluir seus eventos.
                    </p> */}
                        </div>
                      </div></p>
                        {/* <Separator style={{ borderWidth: 0.5, marginTop: 5 }} /> */}
                      </div>
                    ))}
                  </div>
                </div>


              </div>

              {formData.type_appointment=='share' && <>
              <h2 className="text-lg font-semibold mt-4">Controle de Acesso (Agenda compartilhada)</h2>
              <p style={{ marginTop: 5, color: 'grey', fontSize: 13, marginBottom: 10 }}>
                Defina os colaboradores que poderão acessar agenda de outros e aqueles que terão suas agendas disponíveis para agendamento compartilhado
              </p>
              <div style={{ display: 'flex',flexWrap:'wrap', marginTop: 15, marginBottom: 15, justifyContent: 'center', alignItems: 'center' }}>
                <div
                  onClick={(e) => {
                    setSelectTypeShare('own');
                  }}
                  style={{
                    width: 300, height:50, borderRadius: 10, border: '1px solid #f2f2f2', cursor: 'pointer', display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center',
                    background: selectTypeShare == 'own' ? '#1777CF' : 'white',
                    color: selectTypeShare == 'own' ? 'white' : '#1777CF',

                  }}>
                  Quem terá suas agendas acessíveis
                </div>
                <div onClick={(e) => {

                  setSelectTypeShare('third_part');
                }}
                  style={{
                    width: 320, height:50,  borderRadius: 10, border: '1px solid #f2f2f2', cursor: 'pointer', display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center',
                    background: selectTypeShare == 'third_part' ? '#1777CF' : 'white',
                    color: selectTypeShare == 'third_part' ? 'white' : '#1777CF',

                  }}>
                  Quem pode acessar agendas de terceiros
                </div>
              </div>
              {selectTypeShare == 'own' && <div style={{ background: '#f2f2f2', padding: 7, borderRadius: 10, height: 400 }}>

                <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', background: 'white', borderRadius: 10, padding: 10 }}>
                  <b style={{ fontWeight: '500' }}>Setores</b> <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}

                  >
                    {affiliates[0]?.sectors?.map((item, id) => <div onClick={(e) => {
                      setTypeSectorWhoShare(item._id)
                      setSelectedAreaWhoShare({});
                      setSelectedRoleWhoShare({});
                      setSelectedColaboratorWhoShare({});
                    }} style={{ marginLeft: 10, marginRight: 10, color: type_sectorWhoShare == item._id ? '#1777CF' : 'rgba(0, 0, 0, 0.87)' }}>{item.name}</div>)}
                  </div>
                </div>
                <div style={{ display: 'flex', overflow: 'scroll', justifyContent: 'space-between' }}>

                  <div style={{ marginTop: 10, marginRight: 10, background: 'white', width: '32%', minWidth: 200, borderRadius: 10, padding: 10, height: 332, overflow: 'scroll' }}>
                    <b style={{ fontWeight: '500' }}>Áreas</b>
                    {/* <hr/> */}

                    <hr />
                    {type_sectorWhoShare == '' && <p style={{ textAlign: 'center', fontSize: 14, marginTop: 20 }}>Selecione um setor</p>}

                    {affiliates[0]?.areas?.filter((item) => {
                      let sector = affiliates[0]?.sectors?.filter((item2) => item2._id == type_sectorWhoShare)[0];
                      if (sector?.areas?.includes(item._id)) return true;
                      return false;
                    })?.map((item, id) => (
                      <div key={id} style={{ textOverflow: 'ellipsis', padding: 5, marginTop: 10, cursor: 'pointer', border: '1px solid #f2f2f2', borderRadius: 5 }} onClick={(e) => {
                        let items: any = { ...selectedAreaWhoShare };
                        if (items[item._id]) {
                          delete items[item._id]
                        }
                        else {
                          items[item._id] = item;
                        }
                        setSelectedAreaWhoShare(items);
                        // setSelectedRole({});
                        // setSelectedColaborator({});
                      }}><p style={{ color: selectedAreaWhoShare[item._id] ? '#1777CF' : 'rgba(0, 0, 0, 0.87)', display: 'flex', justifyContent: 'space-between' }}><span>{item.name}</span> <span>{item.roles?.length ?? 0}</span></p>
                        {/* <Separator style={{ borderWidth: 0.5, marginTop: 5 }} /> */}
                      </div>
                    ))}
                  </div>
                  <div style={{ marginTop: 10, marginRight: 10, background: 'white', width: '32%', minWidth: 200, borderRadius: 10, padding: 10, height: 332, overflow: 'scroll' }}>
                    <b style={{ fontWeight: '500' }}>Perfis</b>
                    {/* <hr/> */}

                    <hr />
                    {Object.values(selectedAreaWhoShare).length == 0 && <p style={{ textAlign: 'center', fontSize: 14, marginTop: 20 }}>Selecione uma área</p>}

                    {affiliates[0]?.roles.filter((item) => {
                      let areas = Object.values(selectedAreaWhoShare);
                      let find = false;
                      for (let i = 0; i < areas.length; i++) {
                        let area = affiliates[0]?.areas?.filter((item3)=>item3._id==areas[i]._id)[0];

                        find = area?.roles?.includes(item._id)
                        if (find) {
                          break;
                        }
                      }
                      return find;
                    })?.map((item, id) => (
                      <div key={id} style={{ textOverflow: 'ellipsis', padding: 5, marginTop: 10, cursor: 'pointer', border: '1px solid #f2f2f2', borderRadius: 5 }} onClick={(e) => {


                      }}><p style={{ color: selectedRoleWhoShare[item._id] ? '#1777CF' : 'rgba(0, 0, 0, 0.87)', display: 'flex', justifyContent: 'space-between' }}>
                          <div style={{ display: 'flex', background: 'white', borderRadius: 10, padding: 5 }}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  name={'checkbox_client'}
                                  value={selectedRoleWhoShare[item._id]}
                                  checked={selectedRoleWhoShare[item._id]}
                                  onChange={(e) => {
                                    let items: any = { ...selectedRoleWhoShare };
                                    if (items[item._id]) {
                                      delete items[item._id]
                                    }
                                    else {
                                      items[item._id] = item;
                                    }
                                    setSelectedRoleWhoShare(items);
                                    // setSelectedColaborator({});
                                    // if (formData.type_appointment == 'share') {
                                    //   setFormData(prev => ({ ...prev, type_appointment: 'individual' }));

                                    // }
                                    // else {
                                    //   setFormData(prev => ({ ...prev, type_appointment: 'share' }));

                                    // }
                                  }}
                                />
                              }
                            // label={'Agenda compartilhada'}
                            />
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <p style={{ fontSize: 15 }}>{item.name}</p>
                              {/* <p style={{ marginTop: 5, color: 'grey', fontSize: 13 }}>
                      Crie uma cópia individual dessa agenda para cada colaborador com permissão e permite que (Colaboradores específicos) tenham acesso a agendas de outros (Colaboradores específicos) para visualizar, editar e excluir seus eventos.
                    </p> */}
                            </div>
                          </div>
                        </p>
                        {/* <Separator style={{ borderWidth: 0.5, marginTop: 5 }} /> */}
                      </div>
                    ))}
                  </div>
                  <div style={{ marginTop: 10, background: 'white', width: '32%', minWidth: 200, borderRadius: 10, padding: 10, height: 332, overflow: 'scroll' }}>
                    <b style={{ fontWeight: '500' }}>Colaboradores</b>
                    {/* <hr/> */}

                    <hr />
                    {Object.values(selectedRoleWhoShare).length == 0 && <p style={{ textAlign: 'center', fontSize: 14, marginTop: 20 }}>Selecione um perfil</p>}

                    {users?.filter((item) => {
                      let roles = affiliates[0]?.roles?.filter((item2) => selectedRoleWhoShare[item2._id]).map((item2) => item2._id);
                      let roles_2 = affiliates[0]?.roles?.filter((item2) => selectedRoleWhoShare[item2._id]).map((item2) => item2.name);

                      if (roles.includes(item.role) || roles_2.includes(item.role)) {
                        return true;
                      }
                      return false;
                    })?.map((item, id) => (
                      <div key={id} style={{ marginTop: 10, textOverflow: 'ellipsis', padding: 5, cursor: 'pointer', border: '1px solid #f2f2f2', borderRadius: 5 }} onClick={(e) => {
                        let items: any = { ...selectedColaboratorsWhoShare };
                        if (items[item._id]) {
                          delete items[item._id]
                        }
                        else {
                          items[item._id] = item;
                        }
                        setSelectedColaboratorWhoShare(items);
                      }}><p style={{ color: selectedColaboratorsWhoShare[item._id] ? '#1777CF' : 'rgba(0, 0, 0, 0.87)', display: 'flex', justifyContent: 'space-between' }}><div style={{ display: 'flex', background: 'white', borderRadius: 10, padding: 5 }}>

                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <div>
                            <img style={{ borderRadius: 100, minWidth: 30, minHeight: 30, width: 30, height: 30, objectFit: 'cover' }} src={item.photoUrl ? (item.photoUrl instanceof File ? URL.createObjectURL(item.photoUrl) : item.photoUrl) : 'https://microbiology.ucr.edu/sites/default/files/styles/form_preview/public/blank-profile-pic.png?itok=4teBBoet'} />

                          </div>
                          <div style={{ marginLeft: 10 }}>

                            <p style={{ fontSize: 15 }}>{item.name}</p>
                            <p style={{ fontSize: 12, color: 'grey' }}>{affiliates[0]?.roles?.filter((item2) => item2._id == item.role || item2.name == item.role)[0]?.name ?? '-f'}</p>

                          </div>

                          {/* <p style={{ marginTop: 5, color: 'grey', fontSize: 13 }}>
                      Crie uma cópia individual dessa agenda para cada colaborador com permissão e permite que (Colaboradores específicos) tenham acesso a agendas de outros (Colaboradores específicos) para visualizar, editar e excluir seus eventos.
                    </p> */}
                        </div>
                      </div></p>
                        {/* <Separator style={{ borderWidth: 0.5, marginTop: 5 }} /> */}
                      </div>
                    ))}
                  </div>
                </div>


              </div>}


              {selectTypeShare == 'third_part' && <div style={{ background: '#f2f2f2', padding: 7, borderRadius: 10, height: 400 }}>

                <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', background: 'white', borderRadius: 10, padding: 10 }}>
                  <b style={{ fontWeight: '500' }}>Setores</b> <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}

                  >
                    {affiliates[0]?.sectors?.map((item, id) => <div onClick={(e) => {
                      setTypeSectorThirdShare(item._id)
                      setSelectedAreaThirdShare({});
                      setSelectedRoleThirdShare({});
                      setSelectedColaboratorThirdShare({});
                    }} style={{ marginLeft: 10, marginRight: 10, color: type_sectorThirdShare == item._id ? '#1777CF' : 'rgba(0, 0, 0, 0.87)' }}>{item.name}</div>)}
                  </div>
                </div>
                <div style={{ display: 'flex', overflow: 'scroll', justifyContent: 'space-between' }}>

                  <div style={{ marginTop: 10, marginRight: 10, background: 'white', width: '32%', minWidth: 200, borderRadius: 10, padding: 10, height: 332, overflow: 'scroll' }}>
                    <b style={{ fontWeight: '500' }}>Áreas</b>
                    {/* <hr/> */}

                    <hr />
                    {type_sectorThirdShare == '' && <p style={{ textAlign: 'center', fontSize: 14, marginTop: 20 }}>Selecione um setor</p>}

                    {affiliates[0]?.areas?.filter((item) => {
                      let sector = affiliates[0]?.sectors?.filter((item2) => item2._id == type_sectorThirdShare)[0];
                      if (sector?.areas?.includes(item._id)) return true;
                      return false;
                    })?.map((item, id) => (
                      <div key={id} style={{ textOverflow: 'ellipsis', padding: 5, marginTop: 10, cursor: 'pointer', border: '1px solid #f2f2f2', borderRadius: 5 }} onClick={(e) => {
                        let items: any = { ...selectedAreaThirdShare };
                        if (items[item._id]) {
                          delete items[item._id]
                        }
                        else {
                          items[item._id] = item;
                        }
                        setSelectedAreaThirdShare(items);
                        // setSelectedRole({});
                        // setSelectedColaborator({});
                      }}><p style={{ color: selectedAreaThirdShare[item._id] ? '#1777CF' : 'rgba(0, 0, 0, 0.87)', display: 'flex', justifyContent: 'space-between' }}><span>{item.name}</span> <span>{item.roles?.length ?? 0}</span></p>
                        {/* <Separator style={{ borderWidth: 0.5, marginTop: 5 }} /> */}
                      </div>
                    ))}
                  </div>
                  <div style={{ marginTop: 10, marginRight: 10, background: 'white', width: '32%', minWidth: 200, borderRadius: 10, padding: 10, height: 332, overflow: 'scroll' }}>
                    <b style={{ fontWeight: '500' }}>Perfis</b>
                    {/* <hr/> */}

                    <hr />
                    {Object.values(selectedAreaThirdShare).length == 0 && <p style={{ textAlign: 'center', fontSize: 14, marginTop: 20 }}>Selecione uma área</p>}

                    {affiliates[0]?.roles.filter((item) => {
                      let areas = Object.values(selectedAreaThirdShare);
                      let find = false;
                      for (let i = 0; i < areas.length; i++) {
                        let area = affiliates[0]?.areas?.filter((item3)=>item3._id==areas[i]._id)[0];

                        find = area?.roles?.includes(item._id)
                        if (find) {
                          break;
                        }
                      }
                      return find;
                    })?.map((item, id) => (
                      <div key={id} style={{ textOverflow: 'ellipsis', padding: 5, marginTop: 10, cursor: 'pointer', border: '1px solid #f2f2f2', borderRadius: 5 }} onClick={(e) => {


                      }}><p style={{ color: selectedRoleThirdShare[item._id] ? '#1777CF' : 'rgba(0, 0, 0, 0.87)', display: 'flex', justifyContent: 'space-between' }}>
                          <div style={{ display: 'flex', background: 'white', borderRadius: 10, padding: 5 }}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  name={'checkbox_client'}
                                  value={selectedRoleThirdShare[item._id]}
                                  checked={selectedRoleThirdShare[item._id]}
                                  onChange={(e) => {
                                    let items: any = { ...selectedRoleThirdShare };
                                    if (items[item._id]) {
                                      delete items[item._id]
                                    }
                                    else {
                                      items[item._id] = item;
                                    }
                                    setSelectedRoleThirdShare(items);
                                    // setSelectedColaborator({});
                                    // if (formData.type_appointment == 'share') {
                                    //   setFormData(prev => ({ ...prev, type_appointment: 'individual' }));

                                    // }
                                    // else {
                                    //   setFormData(prev => ({ ...prev, type_appointment: 'share' }));

                                    // }
                                  }}
                                />
                              }
                            // label={'Agenda compartilhada'}
                            />
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <p style={{ fontSize: 15 }}>{item.name}</p>
                              {/* <p style={{ marginTop: 5, color: 'grey', fontSize: 13 }}>
                      Crie uma cópia individual dessa agenda para cada colaborador com permissão e permite que (Colaboradores específicos) tenham acesso a agendas de outros (Colaboradores específicos) para visualizar, editar e excluir seus eventos.
                    </p> */}
                            </div>
                          </div>
                        </p>
                        {/* <Separator style={{ borderWidth: 0.5, marginTop: 5 }} /> */}
                      </div>
                    ))}
                  </div>
                  <div style={{ marginTop: 10, background: 'white', width: '32%', minWidth: 200, borderRadius: 10, padding: 10, height: 332, overflow: 'scroll' }}>
                    <b style={{ fontWeight: '500' }}>Colaboradores</b>
                    {/* <hr/> */}

                    <hr />
                    {Object.values(selectedRoleThirdShare).length == 0 && <p style={{ textAlign: 'center', fontSize: 14, marginTop: 20 }}>Selecione um perfil</p>}

                    {users?.filter((item) => {
                      let roles = affiliates[0]?.roles?.filter((item2) => selectedRoleThirdShare[item2._id]).map((item2) => item2._id);
                      let roles_2 = affiliates[0]?.roles?.filter((item2) => selectedRoleThirdShare[item2._id]).map((item2) => item2.name);

                      if (roles.includes(item.role) || roles_2.includes(item.role)) {
                        return true;
                      }
                      return false;
                    })?.map((item, id) => (
                      <div key={id} style={{ marginTop: 10, textOverflow: 'ellipsis', padding: 5, cursor: 'pointer', border: '1px solid #f2f2f2', borderRadius: 5 }} onClick={(e) => {
                        let items: any = { ...selectedColaboratorsThirdShare };
                        if (items[item._id]) {
                          delete items[item._id]
                        }
                        else {
                          items[item._id] = item;
                        }
                        setSelectedColaboratorThirdShare(items);
                      }}><p style={{ color: selectedColaboratorsThirdShare[item._id] ? '#1777CF' : 'rgba(0, 0, 0, 0.87)', display: 'flex', justifyContent: 'space-between' }}><div style={{ display: 'flex', background: 'white', borderRadius: 10, padding: 5 }}>

                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <div>
                            <img style={{ borderRadius: 100, minWidth: 30, minHeight: 30, width: 30, height: 30, objectFit: 'cover' }} src={item.photoUrl ? (item.photoUrl instanceof File ? URL.createObjectURL(item.photoUrl) : item.photoUrl) : 'https://microbiology.ucr.edu/sites/default/files/styles/form_preview/public/blank-profile-pic.png?itok=4teBBoet'} />

                          </div>
                          <div style={{ marginLeft: 10 }}>

                            <p style={{ fontSize: 15 }}>{item.name}</p>
                            <p style={{ fontSize: 12, color: 'grey' }}>{affiliates[0]?.roles?.filter((item2) => item2._id == item.role || item2.name == item.role)[0]?.name ?? '-f'}</p>

                          </div>

                          {/* <p style={{ marginTop: 5, color: 'grey', fontSize: 13 }}>
                      Crie uma cópia individual dessa agenda para cada colaborador com permissão e permite que (Colaboradores específicos) tenham acesso a agendas de outros (Colaboradores específicos) para visualizar, editar e excluir seus eventos.
                    </p> */}
                        </div>
                      </div></p>
                        {/* <Separator style={{ borderWidth: 0.5, marginTop: 5 }} /> */}
                      </div>
                    ))}
                  </div>
                </div>


              </div>}
              </>}

              <h2 className="text-lg font-semibold mb-4 mt-4">Configurações</h2>
              {/* <hr /> */}
              <div style={{ background: '#f2f2f2', padding: 7, borderRadius: 10 }}>

                <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', background: 'white', borderRadius: 10, padding: 10 }}>
                  <div className="grid grid-cols-1  md:grid-cols-3  gap-4 mb-4 mt-4 flex" style={{ flexWrap: 'wrap', display: 'flex', justifyContent: 'start',width:'100%' }}>
                    <div className='w-[100%] md:w-[32%]' style={{ minWidth: 200, position: 'relative' }}>
                      {/* <label className="block mb-2 font-medium">Carência Mínima (dias) *</label>
                <input
                  type="number"
                  name="minimumAdvanceDays"
                  value={formData.minimumAdvanceDays}
                  onChange={handleNumberChange}
                  min="0"
                  className={`p-2 border rounded w-full ${errors.minimumAdvanceDays ? 'border-red-500' : ''}`}
                  required
                /> */}
                      <label className="text-sm font-semibold text-gray-700">
                        Disponibilidade inicial {<b style={{ color: 'red' }}>*</b>}
                      </label>
                      <Input
                        // type="number"
                        name="minimumAdvanceDays"
                        value={formData.minimumAdvanceDays}
                        onChange={handleNumberChange}
                        min="0"
                        required
                        className={`h-12 rounded-xl border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 ${errors.minimumAdvanceDays ? "border-red-500" : ""
                          }`}
                        placeholder={'Disponibilidade inicial (dias)'}
                      />
                      <div style={{ position: 'absolute', right: 30, top: '53%', color: 'gray', background: 'white', fontSize: 14, paddingLeft: 10 }}>
                        Dias
                      </div>
                      {errors.minimumAdvanceDays && <p className="text-red-500 text-sm mt-1">{errors.minimumAdvanceDays}</p>}
                    </div>

                    <div className='w-[100%] md:w-[32%]' style={{ minWidth: 200, position: 'relative' }}>
                      <label className="text-sm font-semibold text-gray-700">
                        Tempo da reunião {<b style={{ color: 'red' }}>*</b>}
                      </label>
                      <Input
                        // type="number"
                        name="maximumFutureDays"
                        value={formData.maximumFutureDays}
                        onChange={handleNumberChange}
                        min="1"
                        className={`h-12 rounded-xl border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 ${errors.maximumFutureDays ? "border-red-500" : ""
                          }`}
                        required
                        placeholder='Tempo da reunião'
                      />
                      <div style={{ position: 'absolute', right: 30, top: '53%', color: 'gray', background: 'white', fontSize: 14, paddingLeft: 10 }}>
                        Minutos
                      </div>
                      {errors.maximumFutureDays && <p className="text-red-500 text-sm mt-1">{errors.maximumFutureDays}</p>}
                    </div>

                    <div className='w-[100%] md:w-[32%]' style={{  minWidth: 200, position: 'relative' }}>
                      <label className="text-sm font-semibold text-gray-700">
                        Intervalo entre reuniões {<b style={{ color: 'red' }}>*</b>}
                      </label>
                      <Input
                        name="intervalMinutes"
                        value={formData.intervalMinutes}
                        onChange={handleNumberChange}
                        min="1"
                        className={`h-12 rounded-xl border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 ${errors.intervalMinutes ? "border-red-500" : ""
                          }`}
                        required
                        placeholder='Intervalo (minutos)'
                      />
                      <div style={{ position: 'absolute', right: 30, top: '53%', color: 'gray', background: 'white', fontSize: 14, paddingLeft: 10 }}>
                        Minutos
                      </div>
                      {errors.intervalMinutes && <p className="text-red-500 text-sm mt-1">{errors.intervalMinutes}</p>}
                    </div>


                  </div>
                  {/* </div> */}

                  {/* Dias da semana */}
                  {/* <div className="mb-6 p-4 bg-gray-50 rounded-lg"> */}
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-2 mb-4" style={{ border: '1px solid lightgrey', borderRadius: 10, padding: 10, display: 'flex', justifyContent: 'space-between', overflow: 'scroll' ,width:'100%'}}>
                    <div>
                      <div style={{ height: 60 }} className="flex items-center">
<label className="text-sm font-semibold text-gray-700">
                              Horários {<b style={{ color: 'red' }}>*</b>}
                            </label>
                      </div>
                      {calculateLoopHour().map((item) => (

                        <>

                          <div className="w-full pr-2 mb-4" style={{ minWidth: 115, height: 48 }}>
                            <label className="text-sm font-semibold text-gray-700">
                              Início {<b style={{ color: 'red' }}>*</b>}
                            </label>
                            <br />

                          </div>

                          <div className="w-full pr-2 mb-2 mb-4" style={{ minWidth: 130, height: 48 }}>
                            <label className="text-sm font-semibold text-gray-700">
                              Término {<b style={{ color: 'red' }}>*</b>}
                            </label>


                          </div>
                        </>))}


                    </div>

                    {Object.entries(formData.weekDayAvailability).map(([day, isAvailable]) => (
                      <div>
                        <div key={day} className="flex items-center mb-1">
                          {/* <input
                    type="checkbox"
                    id={`day-${day}`}
                    checked={isAvailable}
                    onChange={() => handleWeekDayChange(day as keyof WeekDayAvailability)}
                    className="mr-2"
                  /> */}

                          <FormControlLabel
                            control={
                              <Checkbox
                                name={day}
                                checked={isAvailable}
                                onChange={() => handleWeekDayChange(day as keyof WeekDayAvailability)}
                              />
                            }
                            label={day === 'monday' ? 'Segunda' :
                              day === 'tuesday' ? 'Terça' :
                                day === 'wednesday' ? 'Quarta' :
                                  day === 'thursday' ? 'Quinta' :
                                    day === 'friday' ? 'Sexta' :
                                      day === 'saturday' ? 'Sábado' : 'Domingo'}
                          />

                          {/* <label style={{ fontSize: '0.875rem', padding: 5 }} htmlFor={`day-${day}`} className="capitalize">
                    {day === 'monday' ? 'Segunda' :
                      day === 'tuesday' ? 'Terça' :
                        day === 'wednesday' ? 'Quarta' :
                          day === 'thursday' ? 'Quinta' :
                            day === 'friday' ? 'Sexta' :
                              day === 'saturday' ? 'Sábado' : 'Domingo'}
                  </label> */}
                        </div>
                        {formData.timeBlocks[day].map((item3: any, index3: any) => (
                          <>

                            <div className="w-full pr-2 mb-4">

                              <input
                                type="time"
                                value={item3.startTime}
                                style={{ fontSize: '0.875rem', padding: 5 }}

                                onChange={(e) => handleTimeBlockChange(day, index3, 'startTime', e.target.value)}
                                className={`h-12 border w-full rounded-xl border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 ${errors[`timeBlocks[${day}][${index3}].startTime`] ? "border-red-500" : ""
                                  }`}
                                placeholder='Hora de início'
                                required
                              />
                              {errors[`timeBlocks[${day}][${index3}].startTime`] && (
                                <p className="text-red-500 text-xs mt-1">{errors[`timeBlocks[${day}][${index3}].startTime`]}</p>
                              )}
                            </div>

                            <div className="w-full  pr-2 mb-4">

                              <input
                                type="time"
                                value={item3.endTime}
                                style={{ fontSize: '0.875rem', padding: 5 }}

                                onChange={(e) => handleTimeBlockChange(day, index3, 'endTime', e.target.value)}
                                className={`h-12 border w-full rounded-xl border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 ${errors[`timeBlocks[${day}][${index3}].endTime`] ? "border-red-500" : ""
                                  }`} required
                                placeholder='Hora de término'

                              />
                              {errors[`timeBlocks[${day}][${index3}].endTime`] && (
                                <p className="text-red-500 text-xs mt-1">{errors[`timeBlocks[${day}][${index3}].endTime`]}</p>
                              )}
                            </div>
                          </>
                        ))}
                        <div className='text-center mr-3 flex'>
                          <button
                            type="button"
                            style={{width:'45%',display:'flex',justifyContent:'center',alignItems:'center',height:30,marginRight:'10%'}}
                            onClick={() => addTimeBlock(day)}
                            className="bg-blue-500 text-white px-2 py-1 rounded text-sm hover:bg-blue-600 "
                          >
                            <Plus size={20}/>
                          </button>
                          {(
                            <button
                              type="button"
                            style={{width:'45%',display:'flex',justifyContent:'center',alignItems:'center',height:30}}

                              onClick={() => removeTimeBlock(day)}
                              className="bg-red-500 text-white px-2 py-1 rounded text-sm hover:bg-red-600 "
                            >
                              <Trash size={20}/>
                            </button>
                          )}
                        </div>
                      </div>

                    ))}
                  </div>
                </div>
              </div>

              {/* </div> */}

              {/* Blocos de horário */}
              {/* <div className="mb-6 p-4 bg-gray-50 rounded-lg"> */}
              {/* <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-semibold">Blocos de Horário</h2>
              <button
                type="button"
                onClick={addTimeBlock}
                className="bg-blue-500 text-white px-2 py-1 rounded text-sm hover:bg-blue-600"
              >
                + Adicionar Horário
              </button>
            </div> */}

              {errors.timeBlocks && <p className="text-red-500 text-sm mb-2">{errors.timeBlocks}</p>}
              <div style={{ marginBottom: 60 }}></div>



              {/* {formData.timeBlocks.map((block, index) => (
              <div key={index} className="flex flex-wrap items-center mb-3 pb-3 border-b last:border-b-0">
                <div className="w-full md:w-5/12 pr-2 mb-4">
                  <label className="text-sm font-semibold text-gray-700">
                    Hora de início {<b style={{ color: 'red' }}>*</b>}
                  </label>
                  <input
                    type="time"
                    value={block.startTime}
                    style={{ fontSize: '0.875rem', padding: 5 }}

                    onChange={(e) => handleTimeBlockChange(index, 'startTime', e.target.value)}
                    className={`h-12 border w-full rounded-xl border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 ${errors[`timeBlocks[${index}].startTime`] ? "border-red-500" : ""
                      }`}
                    placeholder='Hora de início'
                    required
                  />
                  {errors[`timeBlocks[${index}].startTime`] && (
                    <p className="text-red-500 text-xs mt-1">{errors[`timeBlocks[${index}].startTime`]}</p>
                  )}
                </div>

                <div className="w-full md:w-5/12 pr-2 mb-2 md:mb-0">
                  <label className="text-sm font-semibold text-gray-700">
                    Hora de término {<b style={{ color: 'red' }}>*</b>}
                  </label>
                  <input
                    type="time"
                    value={block.endTime}
                    style={{ fontSize: '0.875rem', padding: 5 }}

                    onChange={(e) => handleTimeBlockChange(index, 'endTime', e.target.value)}
                    className={`h-12 border w-full rounded-xl border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 ${errors[`timeBlocks[${index}].endTime`] ? "border-red-500" : ""
                      }`} required
                    placeholder='Hora de término'

                  />
                  {errors[`timeBlocks[${index}].endTime`] && (
                    <p className="text-red-500 text-xs mt-1">{errors[`timeBlocks[${index}].endTime`]}</p>
                  )}
                </div>

                <div className="w-full md:w-2/12 text-right">
                  {formData.timeBlocks.length > 1 && (
                    <button
                      type="button"
                      onClick={() => removeTimeBlock(index)}
                      className="text-red-500 hover:text-red-700 mt-6"
                    >
                      Remover
                    </button>
                  )}
                </div>

                {errors[`timeBlocks[${index}]`] && (
                  <p className="text-red-500 text-xs w-full mt-1">{errors[`timeBlocks[${index}]`]}</p>
                )}
              </div>
            ))} */}
              {/* </div> */}

              {/* Pool de usuários */}
              {/* <div className="mb-6 p-4 bg-gray-50 rounded-lg"> */}
              {/* <h2 className="text-lg font-semibold mb-4">Atendimento</h2>
              <hr />
              <div className="mb-4 mt-4" style={{ marginBottom: 60 }}>

                <div className="mb-4">
                  <label className="text-sm font-semibold text-gray-700">Perfis Disponíveis para atendimento {<b style={{ color: 'red' }}>*</b>}</label>

                  {affiliatesLoading ? (
                    <div className="border rounded p-4 text-center">
                      <div className="inline-block animate-spin h-5 w-5 border-t-2 border-blue-500 rounded-full mr-2"></div>
                      Carregando perfis...
                    </div>
                  ) : (affiliates.length === 0 || affiliates[0]?.roles.length == 0) ? (
                    <div className="border border-amber-300 bg-amber-50 text-amber-700 p-4 rounded">
                      <p className="font-medium">Nenhum perfil encontrado</p>
                      <p className="text-sm">Verifique se existem perfis cadastrados no sistema.</p>
                    </div>
                  ) : (
                    <>
                      <select
                        name="userPool"
                        value=''
                        onChange={handleProfilePoolChange}
                        style={{ fontSize: '0.875rem', padding: 5 }}
                        className={`h-12 w-full mb-4 border rounded-xl border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 ${errors.userPool ? "border-red-500" : ""
                          }`}
                      >
                        <option value={''}>
                          Selecione um perfil
                        </option>
                        {affiliates[0]?.roles.map((role: any) => (
                          <option key={role._id} value={role._id}>
                            {role.name}
                          </option>
                        ))}
                      </select>
                      {errors.userPool && <p className="text-red-500 text-sm mt-1">{errors.userPool}</p>}
                    </>
                  )}
                  <div className="overflow-x-auto mb-4">
                    <table className="min-w-full bg-white border"
                      style={{ fontSize: '0.875rem' }}

                    >
                      <thead>
                        <tr>
                          <th className="py-2 px-4 border">Nome</th>
                          <th className="py-2 px-4 border">Ações</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Object.values(roles_selects).length > 0 ? (
                          Object.values(roles_selects).map((role: any) => (
                            <tr key={role._id}>
                              <td className="py-2 px-4 border">{role.name}</td>
                              <td className="py-2 px-4 border">
                                <div className="flex space-x-2" style={{ justifyContent: 'center' }}>
                                  <button
                                    onClick={() => handleProfileDelete(role._id as string)}
                                    className="text-red-500 hover:underline"
                                  >
                                    <DeleteIcon />

                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={6} className="py-4 px-4 text-center">
                              Nenhum perfil selecionado.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>

                <label className="text-sm font-semibold text-gray-700">Usuários Disponíveis para atendimento</label>
                {usersLoading ? (
                  <div className="border rounded p-4 text-center mb-4">
                    <div className="inline-block animate-spin h-5 w-5 border-t-2 border-blue-500 rounded-full mr-2"></div>
                    Carregando usuários...
                  </div>
                ) : users.length === 0 ? (
                  <div className="border border-amber-300 bg-amber-50 text-amber-700 p-4 rounded mb-4">
                    <p className="font-medium">Nenhum usuário encontrado</p>
                    <p className="text-sm">Verifique se existem usuários cadastrados no sistema.</p>
                  </div>
                ) : (
                  <>
                    <select
                      name="userPool"
                      value=''
                      onChange={handleUserPoolChange}
                      style={{ fontSize: '0.875rem', padding: 5 }}
                      className={`h-12 w-full mb-4 border rounded-xl border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 ${errors.userPool ? "border-red-500" : ""
                        }`}
                    >
                      <option value={''}>
                        Selecione um usuário
                      </option>
                      {users.filter((item: any) => Object.values(roles_selects).filter((item2: any) => item2.name == item.role).length > 0).map((user: UserOutputDTO) => (
                        <option key={user._id} value={user._id}>
                          {user.name || user.email || `Usuário ${user._id}`}
                        </option>
                      ))}
                    </select>
                    {errors.userPool && <p className="text-red-500 text-sm mt-1">{errors.userPool}</p>}
                  </>
                )}
                <div className="overflow-x-auto mb-4">
                  <table className="min-w-full bg-white border"
                    style={{ fontSize: '0.875rem' }}

                  >
                    <thead>
                      <tr>
                        <th className="py-2 px-4 border">Nome</th>
                        <th className="py-2 px-4 border">E-mail</th>
                        <th className="py-2 px-4 border">Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Object.values(users_selects).length > 0 ? (
                        Object.values(users_selects).map((user: any) => (
                          <tr key={user._id}>
                            <td className="py-2 px-4 border">{user.name}</td>
                            <td className="py-2 px-4 border">{user.email || '-'}</td>
                            <td className="py-2 px-4 border">
                              <div className="flex space-x-2" style={{ justifyContent: 'center' }}>
                                <button
                                  onClick={() => handleDeleteUser(user._id as string)}
                                  className="text-red-500 hover:underline"
                                >
                                  <DeleteIcon />

                                </button>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={6} className="py-4 px-4 text-center">
                            Nenhum usuário selecionado.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div> */}

              {/* <div className='mb-4'>
              <label className="text-sm font-semibold text-gray-700">
                E-mail {<b style={{ color: 'red' }}>*</b>}
              </label>
              <Input
                name="email"

                required
                className={`h-12 rounded-xl border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 ${errors.email ? "border-red-500" : ""
                  }`}
                type={'email'}
                value={formData.email}
                onChange={handleChange}
                placeholder={'Insira um Gmail'}
              />
              {errors.name && <p className="text-red-500 text-sm mt-1">{errors.email}</p>}

            </div> */}

              {/* </div> */}

              {/* Botões de ação */}
              <button hidden type='submit' id='appointment_submit'></button>


            </form>}
          </div>

          <div className="flex gap-4 justify-end" style={{ position: 'absolute', bottom: 0, right: 0, left: 0, padding: 20, backgroundColor: 'white', borderRadius: 20 }}>
            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
              <Button
                type="button"
                onClick={() => navigate('/appointments')}
                variant="outlined"
                disabled={loading_save}
              >
                Cancelar
              </Button>
              <LoadingButton
                type="button"
                onClick={(e) => {
                  // handleSubmit(e);
                  document.getElementById('appointment_submit').click();
                }}
                variant="contained"
                color="primary"
                loading={loading_save}
                disabled={loading_save}
              >
                {isEditing ? 'Salvar' : 'Salvar'}
              </LoadingButton>
            </Box>
            {/* <button
            type="button"
            onClick={() => navigate('/appointments')}
            className="bg-gray-300 px-4 py-2 rounded hover:bg-gray-400"
          >
            Cancelar
          </button>
          <button
            type="submit"
            className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
          >
            {isEditing ? 'Atualizar' : 'Criar'} Configuração
          </button> */}

          </div>

        </CardContent>
      </Card>

    </div>
  );
};

export default AppointmentForm; 